
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Button } from "../../App.styles";
import Modal from "../Modal";
import Textarea from "../Textarea";
import { useCreateAiPhotoMutation } from "./NubsUpload.state";
import Spinner from "../Spinner";

const ModalAiPhoto = ({ onDismiss, show, useQuery, taskId }) => {
    const { game_id } = useParams()
    const { t } = useTranslation()
    const [modalValue, setModalValue] = useState({ prompt: '' })
    const { loading, createAiPhoto } = useCreateAiPhotoMutation({
        game_id,
        taskId,
        useQuery,
        mutationOptions: {
            onSuccess: () => {
                onDismiss()
                setModalValue({ prompt: '' })
            },
            // Error on creation will be shown on a modal
            useErrorBoundary: true,
        }
    })
    const onSave = async e => {
        e.preventDefault()
        const { prompt } = modalValue
        await createAiPhoto(prompt)
    }

    return show
        ? (
            <Modal onDismiss={onDismiss} show={true} size="lg" className="modal--html form-clean">
                <div className="modal-title px-3 py-2">
                    <span dangerouslySetInnerHTML={{ __html: t('AI generated photo') }} />
                </div>
                <div className="modal-body px-3 pb-3">
                    <p dangerouslySetInnerHTML={{
                        __html: t(`Ask our AI to create a photo for your game/challenge. 
                    Tell it what to create. For example, "A photo of a dog wearing a sombrero."`)
                    }} />
                    <Textarea
                        name="prompt"
                        useQuery={() => [modalValue, setModalValue]}
                        mode="clean"
                        rows="5"
                    />
                </div>
                <div className="modal-footer">
                    <Button disabled={loading} className="btn--flat" data-dismiss="modal" onClick={onDismiss} outline>
                        {t('Cancel')}
                    </Button>
                    <Button disabled={loading} className="btn--flat" data-dismiss="modal" onClick={onSave} color="primary">
                        {t('Generate Photo')} {loading ? <Spinner size="0.875rem" /> : null}
                    </Button>
                </div>
            </Modal>
        )
        : null
}

export default ModalAiPhoto